"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultEffects = void 0;
var theme_1 = require("@fluentui/theme");
Object.defineProperty(exports, "DefaultEffects", { enumerable: true, get: function () { return theme_1.DefaultEffects; } });
//# sourceMappingURL=DefaultEffects.js.map